<template>
    <div class="home shrink-text">
        <div style="margin-bottom: 10px;">
            <img alt="skillsync" src="../assets/logo-splash.png" />
        </div>
        <div style="margin-bottom: 15px;">
            <h2>Empower Your Recruitment Strategy without Overspending</h2>
        </div>
        <div class="center-panels" style="width: 60%; ">
            <div class="signup-page">
                <div class="request-access">
                    <h2>Evaluate</h2>
                    <p>Requesting an evaluation starts your journey with us, offering a customized approach to improve your hiring process.</p>
                    <form @submit.prevent="handleRequestAccess">
                        <div class="p-1">
                            <input type="text" v-model="requestAccessData.email" placeholder="Email" required />
                        </div>
                        <div class="p-1">
                            <input type="text" v-model="requestAccessData.firstName" placeholder="First Name" required />
                        </div>
                        <div class="p-1">
                            <input type="text" v-model="requestAccessData.lastName" placeholder="Last Name" required />
                        </div>
                        <div class="p-1">
                            <input type="text" v-model="requestAccessData.company" placeholder="Company" required />
                        </div>
                        <div class="p-1">
                            <button type="submit" class="submit-button">Request Access</button>
                        </div>
                    </form>
                </div>
            <div class="signup-with-code">
                <h2>Signup with Code</h2>
                <p>Please enter your details below if you've received an invite code.</p>
                <form @submit.prevent="acceptInvite">
                    <div class="p-1">
                        <input type="text" v-model="signupData.email" placeholder="Email" required />
                    </div>
                    <div class="p-1">
                        <input type="password" v-model="signupData.password" placeholder="Create Password" required />
                    </div>
                    <div class="p-1">
                        <input type="text" v-model="signupData.inviteCode" placeholder="Invite Code" required />
                    </div>
                    <div class="p-1">
                        <input type="text" v-model="signupData.firstName" placeholder="First Name" required />
                    </div>
                    <div class="p-1">
                        <input type="text" v-model="signupData.lastName" placeholder="Last Name" required />
                    </div>
                    <div class="p-1">
                        <input type="text" v-model="signupData.phoneNumber" placeholder="Phone Number" required />
                    </div>
                    <div class="p-1">
                        <button type="submit" class="submit-button">Sign Up</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <DialogModal :error-message="dialogModalMessage" 
               :error-title="dialogModalTitle" 
               :info-class="dialogInfoClass"
               :modal-emit="true" 
               @close-action="modalClosed"
               ref="dialogModal" />
  </div>
</template>
<script>
import { reactive } from 'vue';
import { getCookie } from '@/utils/cookies/cookieUtils';
import { endpoint } from '@/utils/endpoint/endpointUtils';
import router from '@/router';
import DialogModal from '@/components/DialogModal.vue';

export default {
    components: {
        DialogModal
    },
    data() {
        return {
            dialogModalMessage: 'Thank you for taking an interested in SkillSynchrony. We\'ll keep you posted on your impending invite!',
            dialogModalTitle: 'Request Received',
            dialogInfoClass: 'alert alert-warning',
            requestAccessData : reactive({
                email: '',
                firstName: '',
                lastName: '',
                company: ''
            }),
            signupData : reactive({
                email: '',
                password: '',
                inviteCode: '',
                firstName: '',
                lastName: '',
                phoneNumber: '',
            })            
        }
    },
    methods: {
        async handleRequestAccess () {
            try {
                const response = await fetch(endpoint + '/api/User/RequestAccess', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(this.requestAccessData),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log(data);
                if (data.message === 'Success') {
                    this.dialogModalMessage = "Thank you for taking an interested in SkillSynchrony. We\'ll keep you posted on your impending invite!";
                    this.dialogModalTitle = "Request Received";

                    this.requestAccessData.email = '';
                    this.requestAccessData.firstName = '';
                    this.requestAccessData.lastName = '';
                    this.requestAccessData.company = '';

                } else {
                    this.dialogModalMessage = "There was an issue requesting access.";
                    this.dialogModalTitle = "Access Request Issue";
                }
            } catch(exception) {
                console.log(exception);
                this.dialogModalMessage = "There was an issue requesting access.";
                this.dialogModalTitle = "Access Request Issue";
            }

            this.$refs.dialogModal.openModal();
        },
        async acceptInvite() {
            try {
                const response = await fetch(endpoint + '/api/User/AcceptInvite', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(this.signupData),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log(data);
                if (data.message === 'Success') {
                    this.dialogModalMessage = "Your account has been created and is ready to use.";
                    this.dialogModalTitle = "Account Created";

                    this.signupData.email = '';
                    this.signupData.firstName = '';
                    this.signupData.lastName = '';
                    this.signupData.inviteCode = '';
                    this.signupData.password = '';
                    this.signupData.phoneNumber = '';

                } else {
                    this.dialogModalMessage = "Incorrect invite code or email.";
                    this.dialogModalTitle = "Account Creation Issue";
                }
            } catch(exception) {
                console.log(exception);
                this.dialogModalMessage = "There was an issue creating account.";
                this.dialogModalTitle = "Account Creation Issue";
            }

            this.$refs.dialogModal.openModal();
        },
        handleSignupWithCode() {
            console.log('Signup Data:', this.signupData);
        },
        modalClosed() {
            router.push('/');
        }
    }
}

</script>
<style scoped>
.signup-page {
  display: flex;
  justify-content: space-between;
}
.request-access, .signup-with-code {
  flex-basis: 45%;
  border-width: 1px;
  border-style: solid;
  border-radius: 10px;
  padding: 15px;
  background-color: #181a1b;
}

.center-panels {
    margin-left: auto; margin-right: auto;
}

@font-face {
    font-family: 'montserrat';
    src: url('../assets/fonts/montserrat/Montserrat-ExtraBoldItalic.ttf');
}

h2 {
    font-family: 'montserrat';
    text-shadow: 1px 1px 2px black;
}

/* Media query for smaller screens */
@media screen and (max-width: 768px) {
  .shrink-text {
    /* padding: 10px; Adjust the padding as needed */
    font-size: 10px;
    padding-right: 10px;
  }

  .request-access, .signup-with-code {
    flex-basis: 45%;
    border-width: 1px;
    border-style: solid;
    border-radius: 10px;
    padding: 5px;
    background-color: #181a1b;
    width: 250px;
   }

   .center-panels {
     margin-left: 0%;
     margin-right: 0%;
   }
   
   .submit-button {
    width: 200px;
   }
   input {
    width: 200px;
   }
}
</style>